/**
 * @description: 校验函数
 * @author  黄铭裕 01392190
 * @date 2021-12-06
 */
import zh_cn from './lang/zh-CN'
import zh_hk from './lang/zh-HK'
import vi_vn from './lang/vi-VN'
import ja_jp from './lang/ja-JP'
import th_th from './lang/th-TH'
import ko_kr from './lang/ko-KR'
import en from './lang/en'
import ms_my from './lang/ms-my'
import id_id from './lang/id-id'
import { pwValidateCheck } from '../../api/common/site'
var i18n = {
  zh_cn: zh_cn,
  zh_hk: zh_hk,
  vi_vn: vi_vn,
  ja_jp: ja_jp,
  th_th: th_th,
  ko_kr: ko_kr,
  ms_my: ms_my,
  en: en,
  id_id: id_id
}

/**
 *
 * @param {*} lang  国际化标识   值范围ien zh-CN zh-HK ja-JP ko-KR
 * @num    校验的次数  校验输入的一致性
 * @returns
 *
 */
// 密码校验

var validatePasswordReg = function validatePasswordReg() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en'
  var num = arguments.length > 1 ? arguments[1] : undefined
  var reg = /\-+/g
  var langage = lang.toLocaleLowerCase().replace(reg, '_')
  return function(rule, value, callback) {
    if (num === 1 && !value) {
      return callback(new Error(i18n[langage].password))
    }

    if (num === 2 && !value) {
      return callback(new Error(i18n[langage].passwordAgain))
    } // 密码为8-20位，仅支持大小写字母、数字和符号三种及以上的组合,不支持空格和中文

    var reg = /^(?!.*[\u4E00-\u9FA5\s])(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,20}$/

    if (!reg.test(value)) {
      callback(new Error(i18n[langage].passwordError))
    } else {
      callback()
    }
  }
}

/**
 *
 * @param {*} lang  国际化标识   值范围ien zh-CN zh-HK ja-JP ko-KR
 * @param {*} self  vue 组件实列
 * @param {*} name  属性名  支持嵌套 "form.value.test"
 * @returns
 *
 */
var validatePasswordAgain = function validatePasswordAgain() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en'
  // eslint-disable-next-line no-unused-vars
  var self = arguments.length > 1 ? arguments[1] : undefined
  var name = arguments.length > 2 ? arguments[2] : undefined
  var reg = /\-+/g
  var langage = lang.toLocaleLowerCase().replace(reg, '_')
  return function(rule, value, callback) {
    // eslint-disable-next-line no-eval
    // var ps = eval('self.'.concat(name))
    var ps = name.split('.').reduce(function(o, key) { return (typeof o === 'undefined' ? o : o[key]) }, self)
    if (ps && ps !== value) {
      callback(new Error(i18n[langage].passwordNotSame))
    }

    callback()
  }
}

/**
 * 针对 vant UI 框架的的校验 和element的有区别所以做了区分
 * @param {*} lang   国际化标识   值范围ien zh-CN zh-HK ja-JP ko-KR
 * @param {*} type   pattern  msg
 * @returns
 */

var vant_pattern_reg = function vant_pattern_reg() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en'
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'pattern'
  var reg = /\-+/g
  var langage = lang.toLocaleLowerCase().replace(reg, '_')
  var ps_reg = {
    pattern: /^(?!.*[\u4E00-\u9FA5\s])(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,20}$/,
    msg: i18n[langage].passwordError
  }
  return ps_reg[type]
}
/**
 *
 * @param {*} lang  国际化标识值范围en zh-CN zh-HK ja-JP ko-KR
 * @requiredMsg    自定义的验证码必填校验的国际化错误信息
 * @returns
 *
 */
// 验证码（包括手机短信验证码、邮箱验证码）的校验

var validateVerifyCodeReg = function validateVerifyCodeReg() {
  var requiredMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en'
  var reg = /\-+/g
  var langage = lang.toLocaleLowerCase().replace(reg, '_')
  return function(rule, value, callback) {
    if (!value) {
      var msg = i18n[langage].requiredVerifyCode || requiredMsg
      return callback(msg)
    } // 验证码仅支持6位0-9之间的数字

    var reg = /^\d{6}$/

    if (!reg.test(value)) {
      callback(new Error(i18n[langage].verifyCode))
    } else {
      callback()
    }
  }
}

/**
 * 密码校验规则验证
 * @param {*} value 密码值
 * @returns {Promise<{isValid: boolean, rules: Array}>} 返回验证结果和规则列表
 */
// 添加防抖函数
function debounce(fn, delay) {
  let timer = null
  return function(...args) {
    if (timer) {
      clearTimeout(timer)
    }
    return new Promise((resolve) => {
      timer = setTimeout(async() => {
        const result = await fn.apply(this, args)
        resolve(result)
      }, delay)
    })
  }
}

// 将原始的密码验证函数包装成防抖版本
const debouncedValidatePasswordRules = debounce(async(value, _language) => {
  try {
    const formData = new FormData()
    formData.append('pw', value)
    formData.append('lang', _language)

    const response = await pwValidateCheck(formData)
    const rules = response.data || []
    const isValid = rules.every(rule => rule.flag)

    return {
      isValid,
      rules: rules
    }
  } catch (error) {
    console.error('Password validation failed:', error)
    return {
      isValid: false,
      rules: []
    }
  }
}, 500) // 300ms 的防抖延迟

// 修改原有的 validatePasswordRules 函数
const validatePasswordRules = async function validatePasswordRules(value, _language) {
  return await debouncedValidatePasswordRules(value, _language)
}

/**
 * 创建密码字段验证器
 * @param {*} language 语言
 * @param {*} formRef 表单ref
 * @param {*} confirmFieldName 确认密码字段名
 * @returns {Function} 验证器函数
 */
const createPasswordValidator = function createPasswordValidator(_language, formRef, confirmFieldName, afterFetch = () => true) {
  return async(rule, value, callback) => {
    var reg = /\-+/g
    var language = _language.toLocaleLowerCase().replace(reg, '_')
    if (!value) {
      callback(new Error(i18n[language].password))
      return
    }

    const { isValid, rules } = await validatePasswordRules(value, _language)

    // 更新组件的密码规则状态
    if (formRef && formRef.passwordRules && afterFetch()) {
      formRef.passwordRules = rules
      formRef.passwordRulesVisible = !isValid
    } else {
      formRef.passwordRulesVisible = false
      formRef.passwordRules = []
    }

    if (!isValid) {
      callback(new Error(' '))
    } else {
      callback()
    }

    // 验证确认密码字段
    if (formRef && confirmFieldName) {
      formRef.$refs.form?.validateField(confirmFieldName)
    }
  }
}

export default {
  validatePasswordReg: validatePasswordReg,
  validatePasswordAgain: validatePasswordAgain,
  vant_pattern_reg: vant_pattern_reg,
  validateVerifyCodeReg: validateVerifyCodeReg,
  validatePasswordRules: validatePasswordRules,
  createPasswordValidator: createPasswordValidator
}
